import * as React from 'react';
import styles from './index.less';
import * as AHooks from 'ahooks';
import Sortable, { type SortableEvent } from 'sortablejs';

interface ItemInterface {
  /** The unique id associated with your item. It's recommended this is the same as the key prop for your list item. */
  id: string | number;
  /** When true, the item is selected using MultiDrag */
  // selected?: boolean;
  /** When true, the item is deemed "chosen", which basically just a mousedown event. */
  // chosen?: boolean;
  /** When true, it will not be possible to pick this item up in the list. */
  // filtered?: boolean;
  [property: string]: any;
}

interface FReactSortableProps<T extends ItemInterface = ItemInterface> {
  list?: T[];
  setList?: (newState: T[]) => void;
  style?: React.CSSProperties;
  className?: string;
  options?: Sortable.Options;
  children: React.ReactNode[];
}

function FReactSortable<T extends ItemInterface = ItemInterface>({
  list,
  setList,
  style,
  className,
  options = {},
  children,
}: FReactSortableProps<T>) {
  const ref_sortable = React.useRef<HTMLDivElement>(null);

  const latestListRef = AHooks.useLatest<T[]>(list ?? []);

  AHooks.useMount(() => {
    const el = ref_sortable.current!;
    const { onEnd, ...restOptions } = options;
    const sortable = new Sortable(el, {
      ...restOptions,
      onEnd: (evt: SortableEvent) => {
        onEnd?.(evt);
        if (!list || !setList) {
          return;
        }
        const selectInputs: T[] = [...latestListRef.current];
        const newIndex: number = evt.newDraggableIndex ?? -1;
        const oldIndex: number = evt.oldDraggableIndex ?? -1;
        const outSelectInputs = selectInputs.splice(oldIndex, 1);
        selectInputs.splice(newIndex, 0, ...outSelectInputs);
        setList(selectInputs);
      },
    });
  });

  return (
    <div className={className} style={style} ref={ref_sortable}>
      {children}
    </div>
  );
}

export default FReactSortable;
